import React from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './CustomPage.css';
import Home from "./Components/Home"
import Login from "./Components/Login";
//import ErrorPage from "./Components/ErrorPage";
import { useState, useEffect } from "react";
import { authenticate } from './services/user-services';
import "./services/interceptor";
import { AuthenticatedTemplate, UnauthenticatedTemplate, useIsAuthenticated, useMsal } from "@azure/msal-react";
import { loginRequest } from "./authConfig";
//import { useNavigate } from 'react-router-dom';

function App() {
  const isAuthenticated = useIsAuthenticated();
  const { instance, accounts } = useMsal();
  const [validUser, setValidUser] = useState();
  const [idToken, setIdToken] = useState(null);


  //const navigate = useNavigate();
  //For Local
  //useEffect(() => {
  // getUserData();
  //}
  //);



  useEffect(() => {
    // // debugger;
    if (isAuthenticated) {
      RequestProfileData();
    }
    if (idToken && idToken != "") {
      localStorage.setItem("Token",idToken);
      getUserData();
    }
  }, [isAuthenticated, idToken]);

  function RequestProfileData() {
    // // debugger;
    const request = {
      ...loginRequest,
      account: accounts[0]
    };
    // Silently acquires an access token which is then attached to a request for Microsoft Graph data
    instance.acquireTokenSilent(request).then((response) => {
      console.log("🔹 ID Token:", response);
      console.log("🔹 Access Token:", response.accessToken);
      setIdToken(response.idToken);
    }).catch((e) => {
      instance.acquireTokenPopup(request).then((response) => {
        setIdToken(response.idToken);
      });
    });
  }
  //Code for Live

  async function getUserData() {
    // debugger;
    if (!idToken) {
      console.error("ID Token is missing. Cannot send request to backend.");
      return;
    }

    console.log(" Sending ID Token to Backend:", idToken);

    let email = accounts[0]?.username;
    if (!email) {
      console.error(" Email is missing");
      return;
    }

    try {
      let result = await authenticate(idToken, email);
      console.log("Backend Response:", result.data);
      console.log("Backend Response:", result);
      if (result.data.UserData != "") {
        console.log("UserData", result.data.UserData);
        localStorage.setItem('UserName', result.data.UserData.userName);
        localStorage.setItem('UserId', result.data.UserData.emailId);
        localStorage.setItem('UserId1', result.data.UserData.emailId);
        localStorage.setItem('Role', result.data.UserData.accessRole);
        //localStorage.setItem('Token', result.data.Token);
        localStorage.setItem('Team', result.data.UserData.team);
        setValidUser(true);
        //navigate("/approvalrequest");
      } else {
        setValidUser(false);
      }
    }
    catch (err) {
      console.log("Error fetching user data", err);
    }

  }
  // async function getUserData() {

  //   //// debugger;
  //   let email = accounts[0].username;
  //   console.log("Inside getUserData");
  //   console.log("idToken =====> ", idToken);
  //   let result = await authenticate(idToken, email).catch(err =>
  //     console.log("Error in fetching details", err));

  //   if (result.data.UserData != "") {
  //     console.log("result.data.UserData=====> ", result.data.UserData);
  //     console.log("result.data.Token =====> ", result.data.Token);
  //     localStorage.setItem('UserName', result.data.UserData.userName);
  //     localStorage.setItem('UserId', result.data.UserData.emailId);
  //     localStorage.setItem('UserId1', result.data.UserData.emailId);
  //     localStorage.setItem('Role', result.data.UserData.accessRole);
  //     localStorage.setItem('Token', result.data.Token);
  //     localStorage.setItem('Team', result.data.UserData.team);
  //     setValidUser(true);
  //     //navigate("/approvalrequest");
  //   } else {
  //     setValidUser(false);
  //   }
  // }

  // End Code for Live
  //  Code for Local
  // async function getUserData() {

  //  localStorage.setItem('UserName', "Vikas Katkar");
  // localStorage.setItem('UserId', "vikastr@godrej.com");
  // }

  // async function getUserData() {
  //   localStorage.setItem('UserName', "Aneev Ansari");
  //   localStorage.setItem('UserId', "aneev@godrej.com");
  // }

  // async function getUserData() {   
  //   localStorage.setItem('UserName',"Govind Rathore");
  //   localStorage.setItem('UserId', "gsr@godrej.com");      
  // }

  // async function getUserData() {
  //   localStorage.setItem('UserName', "Gauresh Zarbade");
  //   localStorage.setItem('UserId', "gauresh@godrej.com");
  // }

  //  End Code for Local
  //   return (
  //     <Home />
  //   );


  return (<>
    {/* <Home /> */}
    <AuthenticatedTemplate>
      {validUser == true && <Home />}
      {/* {validUser == false && <ErrorPage validUser={validUser} />} */}
    </AuthenticatedTemplate>
    <UnauthenticatedTemplate>
      <Login />
    </UnauthenticatedTemplate>
  </>
  );

}
export default App;
